import type { SxProp } from 'src/types/mui';

export const viewReportButtonStyles: SxProp = () => ({
  borderRadius: 1,
  boxShadow: 'unset',
});

export const requestBodyContainerCVStyles: SxProp = theme => ({
  padding: '24px 32px',
  background: theme.palette.common.white,
  borderRadius: 2,
  border: '1px solid',
  borderColor: theme.palette.secondary.main,
});

export const requestBodyContainerStyles: SxProp = theme => ({
  padding: '20px 24px',
  background: theme.palette.common.white,
  borderRadius: 2,
  border: '1px solid',
  borderColor: theme.palette.secondary.main,
});
